import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { useSolutions, useSiteImages } from "../content/useContent";
import { IconByName } from "../components/IconByName";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { FinalCTA } from "../components/FinalCTA";
import { ArrowRight } from "lucide-react";
import { useBoot } from "../components/Layout";

const Solutions = () => {
  const { lang, t, p } = useLang();
  const boot = useBoot();
  const solutions = useSolutions();
  const IMG = useSiteImages();
  const showTv = boot?.settings?.claims?.show_tv_bouquet;
  const tvLabel = lang === "fr" ? (boot?.settings?.claims?.tv_bouquet_label_fr || "Bientôt disponible") : (boot?.settings?.claims?.tv_bouquet_label_en || "Coming soon");

  return (
    <div data-testid="solutions-page">
      <Seo title={t.nav.solutions} path="solutions" />
      <PageHero eyebrow="BULA TELECOMS SA" title={t.solutionsHome.heading} sub={t.solutionsHome.intro}
        image={IMG.fiberWork} crumbs={[{ label: t.nav.solutions }]} />

      <section className="bg-[#F5F5F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24 grid grid-cols-1 md:grid-cols-2 gap-6">
          {solutions.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 90}>
              <Link to={p(`solutions/${s.slug}`)} data-testid={`solution-list-${s.slug}`}
                className="group flex gap-5 bg-white border border-[#101214]/10 rounded-2xl p-7 h-full hover:border-[#FF6600]/50 hover:shadow-[0_12px_40px_rgba(255,102,0,0.1)] transition-all">
                <span className="shrink-0 inline-flex w-12 h-12 rounded-xl bg-[#101214] text-[#FF6600] items-center justify-center group-hover:bg-[#FF6600] group-hover:text-[#08090A] transition-colors">
                  <IconByName name={s.icon} />
                </span>
                <div>
                  <h2 className="text-lg font-bold text-[#101214]">{s[lang].title}</h2>
                  <p className="mt-2 text-sm text-[#101214]/60 leading-relaxed">{s[lang].short}</p>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-black text-[#FF6600] uppercase tracking-wider">
                    {lang === "fr" ? "Découvrir" : "Discover"} <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
          {showTv && (
            <Reveal>
              <div className="flex gap-5 bg-white/60 border border-dashed border-[#101214]/20 rounded-2xl p-7 h-full" data-testid="tv-bouquet-teaser">
                <span className="shrink-0 inline-flex w-12 h-12 rounded-xl bg-[#FFC000]/20 text-[#FFC000] items-center justify-center"><IconByName name="Satellite" /></span>
                <div>
                  <h2 className="text-lg font-bold text-[#101214]/70">{lang === "fr" ? "Bouquet TV" : "TV bouquet"}</h2>
                  <span className="mt-2 inline-block text-xs font-black uppercase tracking-wider bg-[#FFC000]/25 text-[#8a6d00] rounded-full px-3 py-1">{tvLabel}</span>
                </div>
              </div>
            </Reveal>
          )}
        </div>
      </section>
      <FinalCTA />
    </div>
  );
};

export default Solutions;
